import type { VariantMetadata } from "./types";

/**
 * Pads or truncates a variant-metadata array so it matches a target variant length.
 * Missing entries become empty objects so indices stay aligned with `components`.
 *
 * @param metadata - Existing metadata hashes (may be shorter/longer than `length`)
 * @param length - Desired array length (typically the component values length)
 * @returns Index-aligned metadata array of exactly `length`
 */
export const alignVariantMetadataToLength = (
  metadata: VariantMetadata[] | undefined,
  length: number
): VariantMetadata[] => {
  const current = metadata ?? [];
  return Array.from({ length }, (_, index) => ({ ...(current[index] ?? {}) }));
};
